import { createSlice, isAnyOf } from '@reduxjs/toolkit';
import { getCart, getAlmaPaymentMethod, setGuestEmail, getCustomerAddresses, getCountries, setShippingMethod, setPaymentMethod as setPaymentMethod$1, setCustomerShippingAddress, setCustomerShippingAddressById, setCustomerBillingAddress, setCustomerBillingAddressById, setCouponCode, removeCouponCode } from './thunks.js';
import { sortPaymentMethods } from './helper.js';
import { initialState } from './initialState.js';
import '../../types/index.js';
import { C as CheckoutSection } from '../../checkout-Ee1eEXQH.js';
import '../../menu-0TyOg98i.js';
import '../../product-_pRduMz7.js';
import '../../modal-6vnX5SO3.js';
import 'lodash/get';
import '../../services/auth/index.js';
import '../../utils/logToSlack.js';
import '../../utils/cookies.js';
import 'cookies-next';
import '../../cookies-l-jEMp6P.js';
import '../../currency-_kacFJHO.js';
import '../../language-BHHwgtQp.js';
import '../../payment-YC9H491Y.js';
import '../../utils/isBot.js';
import '../../utils/currency.js';
import 'react';
import '../../context/index.js';
import 'next/server';
import '../../index-Oip0gjfj.js';
import 'next/router';
import '../../helpers-kA_hdoOI.js';
import '../../utils/product.js';
import '../../paths-ZKN3m62_.js';
import 'lodash';
import '../../GetCustomerAddress--OLlOu1N.js';
import '../../GetAlmaPaymentMethod-u8bKjts8.js';
import '../../GetCountries-GDHcTLyd.js';
import '../../GenerateCustomerToken-nBNO7Rhh.js';
import '../../requestsCollection-mMBLWoZb.js';
import 'graphql-request';
import 'lodash/cloneDeep';
import '../../utils/fetchPolicyLookup.js';
import '../../utils/cart.js';
import '../../MergeCarts-wo9UjKo5.js';
import '../../ProcessReactivateCart-fk5bSKoR.js';
import '../../utils/price.js';
import 'number-currency-format';
import '../../cart-Vtx0Wqgk.js';
import '../../serverErrors-_VHsjhgw.js';
import '../../utils/error.js';
import '../../utils/logger.js';
import '../../utils/logToRelic.js';

const checkoutSlice = createSlice({
    name: 'checkoutSlice',
    initialState,
    reducers: {
        setPaymentMethod: (state, { payload }) => {
            state.cart.selected_payment_method = payload;
        },
        resetProcessPayment: state => {
            state.processPayment = initialState.processPayment;
        },
        setGeneralStatus: (state, { payload }) => {
            state.processPayment.generalStatus = payload;
        },
        setValidationStatus: (state, { payload }) => {
            const { section, status } = payload;
            switch (section) {
                case CheckoutSection.Email:
                    state.processPayment.validationStatus.email = status;
                    break;
                case CheckoutSection.Shipping:
                    state.processPayment.validationStatus.shipping = status;
                    break;
                case CheckoutSection.Billing:
                    state.processPayment.validationStatus.billing = status;
                    break;
                case CheckoutSection.PaymentMethod:
                    state.processPayment.validationStatus.paymentMethod = status;
                    break;
            }
        },
        setRequestStatus: (state, { payload }) => {
            const { section, status } = payload;
            switch (section) {
                case CheckoutSection.Email:
                    state.processPayment.requestStatus.email = status;
                    break;
                case CheckoutSection.Shipping:
                    state.processPayment.requestStatus.shipping = status;
                    break;
                case CheckoutSection.PaymentMethod:
                    state.processPayment.requestStatus.paymentMethod = status;
                    break;
            }
        },
        setLoadingShippingFeeAndPaymentMethod: (state, { payload }) => {
            state.loadingShippingFeeAndPaymentMethod = payload;
        },
        setLoadingPaymentButton: (state, { payload }) => {
            state.loadingPaymentButton = payload;
        },
        setPayload: (state, { payload }) => {
            const { section, value } = payload;
            switch (section) {
                case CheckoutSection.Email:
                    state.processPayment.payload.email = value;
                    break;
                case CheckoutSection.Shipping:
                    state.processPayment.payload.shipping = value;
                    break;
                case CheckoutSection.Billing:
                    state.processPayment.payload.billing = value;
                    break;
                case CheckoutSection.PaymentMethod:
                    state.processPayment.payload.paymentMethod = value;
                    break;
            }
        },
        updateCustomerData: (state, { payload }) => {
            state.updateCustomerData.initCount += 1;
            state.updateCustomerData.payload = payload;
        },
        setExpressPaymentMethod: (state, { payload }) => {
            state.expressPaymentMethod = payload;
        },
        setExtraErrors: (state, { payload }) => {
            state.extraErrors = payload;
        },
    },
    extraReducers: builder => {
        builder.addCase(getCart.fulfilled, (state, { payload }) => {
            state.cart = {
                ...payload,
                available_payment_methods: sortPaymentMethods(payload.available_payment_methods),
            };
        });
        builder.addCase(getAlmaPaymentMethod.fulfilled, (state, { payload }) => {
            state.almaPaymentMethod = payload;
        });
        builder.addCase(setGuestEmail.fulfilled, (state, { payload }) => {
            state.cart.email = payload;
        });
        builder.addCase(getCustomerAddresses.fulfilled, (state, { payload }) => {
            state.addresses = payload;
        });
        builder.addCase(getCountries.fulfilled, (state, { payload }) => {
            state.countries = payload;
        });
        builder.addCase(setShippingMethod.fulfilled, (state, { payload }) => {
            state.cart.check_mattress_recovery = payload.check_mattress_recovery;
            state.cart.shipping_addresses = payload.shipping_addresses;
            state.cart.available_payment_methods = sortPaymentMethods(payload.available_payment_methods);
            state.cart.prices = payload.prices;
        });
        builder.addCase(setPaymentMethod$1.fulfilled, (state, { payload }) => {
            state.cart.selected_payment_method = payload;
        });
        builder.addMatcher(isAnyOf(setCustomerShippingAddress.fulfilled, setCustomerShippingAddressById.fulfilled), (state, { payload }) => {
            state.cart.shipping_addresses = payload;
        });
        builder.addMatcher(isAnyOf(setCustomerBillingAddress.fulfilled, setCustomerBillingAddressById.fulfilled), (state, { payload }) => {
            state.cart.billing_address = payload.billing_address;
            state.cart.available_payment_methods = sortPaymentMethods(payload.available_payment_methods);
        });
        builder.addMatcher(isAnyOf(setCouponCode.fulfilled, removeCouponCode.fulfilled), (state, { payload }) => {
            state.cart.shipping_addresses = payload.shipping_addresses;
            state.cart.prices = payload.prices;
            state.cart.applied_coupons = payload.applied_coupons;
        });
    },
});
const { setPaymentMethod, resetProcessPayment, setGeneralStatus, setRequestStatus, setValidationStatus, setPayload, setLoadingShippingFeeAndPaymentMethod, setLoadingPaymentButton, updateCustomerData, setExpressPaymentMethod, setExtraErrors, } = checkoutSlice.actions;
var index = checkoutSlice.reducer;

export { index as default, resetProcessPayment, setExpressPaymentMethod, setExtraErrors, setGeneralStatus, setLoadingPaymentButton, setLoadingShippingFeeAndPaymentMethod, setPayload, setPaymentMethod, setRequestStatus, setValidationStatus, updateCustomerData };
//# sourceMappingURL=index.js.map
